<!--
  Modal Component
  Dialog with backdrop. Closes on backdrop click or Escape key.
-->
<script lang="ts">
  import { createEventDispatcher, onMount, onDestroy } from 'svelte';

  export let open = false;
  export let title: string | undefined = undefined;

  const dispatch = createEventDispatcher<{ close: void }>();

  function close() {
    dispatch('close');
  }

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') close();
  }

  function handleBackdropClick(e: MouseEvent) {
    if (e.target === e.currentTarget) close();
  }

  onMount(() => {
    document.addEventListener('keydown', handleKeydown);
  });

  onDestroy(() => {
    document.removeEventListener('keydown', handleKeydown);
  });
</script>

{#if open}
  <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xs"
    on:click={handleBackdropClick}
  >
    <div
      class="bg-surface border border-border rounded-xl shadow-card w-full max-w-md mx-4 p-5"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      data-testid="modal"
    >
      {#if title}
        <div class="flex items-center justify-between pb-3 mb-3 border-b border-border">
          <h2 class="text-lg font-semibold text-text">{title}</h2>
          <button
            type="button"
            class="p-1 text-text-muted hover:text-text bg-transparent border-none cursor-pointer rounded transition-colors"
            on:click={close}
            aria-label="Close"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
      {/if}

      <slot />

      {#if $$slots.footer}
        <div class="flex flex-wrap items-center justify-end gap-2 pt-4 mt-4 border-t border-border">
          <slot name="footer" />
        </div>
      {/if}
    </div>
  </div>
{/if}
